import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import { createDisplayDate, DisplayDate, OwaDate, owaDate } from 'owa-datetime';

/**
 * Converts a owaDate into a local representation of DisplayDate
 * @param date The date to convert
 * @param timeZone The desired time zone, defaults to userConfiguration's time zone
 */
export default function owaDateToDisplayDate(date: OwaDate, timeZone?: string): DisplayDate {
    if (!timeZone) {
        timeZone = getUserConfiguration().UserOptions.TimeZone;
    }

    const localTime = owaDate(timeZone, date);
    return createDisplayDate(
        localTime.getFullYear(),
        localTime.getMonth(),
        localTime.getDate(),
        localTime.getHours(),
        localTime.getMinutes(),
        localTime.getSeconds(),
        localTime.getMilliseconds()
    );
}
